import { render, staticRenderFns } from "./RegistrationSimple.vue?vue&type=template&id=560ca14b&scoped=true&"
import script from "./RegistrationSimple.vue?vue&type=script&lang=js&"
export * from "./RegistrationSimple.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationSimple.vue?vue&type=style&index=0&id=560ca14b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560ca14b",
  null
  
)

export default component.exports